import { mount, type Component } from 'svelte';
import './app.css';
import AppRoot from './app.svelte';
import DebugGraph from './components/debug/debug-graph.svelte';
import DebugWalk from './components/debug/debug-walk.svelte';
import PenPage from './components/pen.svelte';

/** Hash → non-app page lookup. Anything else falls back to the main app. */
const DEBUG_ROUTES: ReadonlyMap<string, Component> = new Map([
  ['#/debug/walk', DebugWalk],
  ['#/debug/graph', DebugGraph],
  ['#/pen', PenPage],
]);

/** Picks the root component based on `location.hash`. Non-debug hashes hit `AppRoot`. */
function selectRoot(hash: string): Component {
  return DEBUG_ROUTES.get(hash) ?? AppRoot;
}

const target = document.querySelector('#app');
if (!target) {
  throw new Error('Missing #app mount node');
}

export default mount(selectRoot(location.hash), { target });
